<script setup>
import notification from "@/utils/plugins/NotificationService";
import HeaderTitle from "@/components/layout/HeaderTitle.vue";
import SharedElementPagination from "@/components/shared/SharedElementPagination.vue";
import Services from "@/api/services/newPresencia.service";
import ResourceService from "@/api/services/resource.service";
import moment from 'moment';

import { computed, h, onMounted, ref, shallowRef } from "vue";
import { usePresenceStore } from "@/app/stores/presenceStore";
import { useUiStore } from "@/app/stores/uiStore";
import SharedButtonPlus from "@/components/shared/SharedButtonPlus.vue";
import PresenceDialogChanges from "@/components/shared/Presence/PresenceDialogChanges.vue";
import { useRoute, useRouter } from "vue-router";

// Variables reactivas
const pageSignings = ref(1);
const itemsPerPageSignings = ref(10)
const totalSignins = ref(0);
const daterange = ref([])
const employeeName = ref('')
const allPresenceChanges = ref([])
const department = ref(null)
const departments = ref([])
const fechaDesde = ref(null)
const fechaHasta = ref(null)
const showTable = ref(false);
const state = ref(null);
const states = ref([{ es: 'Pendiente', en: 'pending' }, { es: 'Aprobado', en: 'approved' }, { es: 'Rechazado', en: 'rejected' }])

const employeePresenceChanges = ref([]);

const presenceStore = usePresenceStore();
const uiStore = useUiStore();
const route = useRoute();
// eslint-disable-next-line no-unused-vars
const router = useRouter();

// Icono personalizado para el DatePicker
const customPrefix = shallowRef({
    render() {
        return h('img', {
            src: '/calendar-blue.svg',
            style: 'width: 16px; height: 16px; margin-right: 10px;'
        })
    }
})

//See employee presence changes
const isDialogVisible = computed(() => !!route.params.id)

// Ciclo de vida
onMounted(async () => {
    await getPresencesPetitions()
    await getDepartments()
})

const getPresencesPetitions = () => {
    const params = {
        page: pageSignings.value,
        itemsPerPage: itemsPerPageSignings.value,
        'order[requestedRecordedAt]': 'DESC',
    }
    if (daterange.value[0]) {
        params.from = moment(daterange.value[0]).startOf('day').format('YYYY-MM-DD');
    }
    if (daterange.value[1]) {
        params.to = moment(daterange.value[1]).startOf('day').format('YYYY-MM-DD');
    }

    if (employeeName.value) {
        if (employeeName.value.length === 1) {
            employeeName.value = employeeName.value.toUpperCase()
        }
        params.name = employeeName.value
    }
    if (department.value) {
        params.department = department.value;
    }

    if (state.value) {
        params.status = state.value;
    }
    Services.getWorkRecordsRequestAdmin(params)
        .then(response => {
            if (!response) return;

            if (!response.data) {
                return;
            }
            totalSignins.value = response.data['hydra:totalItems'];
            allPresenceChanges.value = response.data['hydra:member'].filter(e => e.employee.fullName);
            showTable.value = true;
            presenceStore.setReportPresence(allPresenceChanges.value)
            presenceStore.setDateRangeReport(daterange.value)
            if (route.params && route.params.id) {
                const id = route.params.id;
                for (let i = 0; i < allPresenceChanges.value.length; i++) {
                    const element = allPresenceChanges.value[i];
                    if (element.employee.id == id) {
                        openDialog(element);
                    }
                }
            }
        })

}

const getDaysWithRequests = (daysWithRequests) => {

    const days = Object.keys(daysWithRequests).length;

    if (days == 1) {
        return "Tienes " + days + " día con cambios"
    } else {
        return "Tienes " + days + " días con cambios"
    }
}

const getDepartments = (searchQuery = '') => {
    const params = searchQuery.length > 0 ? { name: searchQuery } : {}
    params['order[name]'] = 'ASC'
    ResourceService.getDepartments(params)
        .then(res => {
            departments.value = res.data['hydra:member']
        })
        .catch(() => {
            notification.addNotification({
                message: 'Error al obtener los departamentos',
                type: 'error'
            })
        })
}

const disableDateFrom = (date) => {
    if (fechaHasta.value) {
        return date > fechaHasta.value
    }
    return false
}

const disableDateTo = (date) => {
    if (fechaDesde.value) {
        return date < fechaDesde.value
    }
    return false
}

const watchChangeFrom = (val) => {
    if (fechaHasta.value && val > fechaHasta.value) {
        fechaHasta.value = null
    }
    daterange.value[0] = fechaDesde.value;
    pageSignings.value = 1;
    getPresencesPetitions();
}

const watchChangeTo = (val) => {
    if (val) {
        if (fechaDesde.value && val < fechaDesde.value) {
            fechaDesde.value = null
        }
    }
    daterange.value[1] = fechaHasta.value;
    pageSignings.value = 1;
    getPresencesPetitions();
}

const searchByName = () => {
    pageSignings.value = 1;
    getPresencesPetitions();
}


// Dialog

const openDialog = (sign) => {
    orderPresence(sign.requestsByDay)
    router.push({ path: `/manage-presence/${sign.employee.id}` });
}

const closeSeeChanges = () => {
    router.push({ path: `/manage-presence/` });
}

const orderPresence = (array) => {
    employeePresenceChanges.value = [];
    const newArray = Object.entries(array).map(([day, requests]) => ({
        day,
        requests,
        isAccepted: true,
    }))
    for (let i = 0; i < newArray.length; i++) {
        const [año, mes, dia] = newArray[i].day.split('-');
        newArray[i].day = `${dia}-${mes}-${año}`;
    }
    employeePresenceChanges.value = newArray;
}

const finishDialogChanges = () => {
    notification.addNotification({
        type: 'success',
        message: 'Cambios terminados',
        duration: 6000
    })
    closeSeeChanges();
    getPresencesPetitions();
}

const changePagination = () => {
    getPresencesPetitions();
}

</script>

<template>
    <div>
        <!-- Cabecera -->
        <HeaderTitle title="Gestión de Fichajes" />
        <el-card class="card-search w-100 p-5" body-style="padding:0">
            <form>
                <div class="form-item mb-3 row mx-0">
                    <div class="col-md-4 el-col-xs-24">
                        <label class="col-md-12 w-100">Nombre</label>
                        <el-input clearable v-model="employeeName" placeholder="Nombre" @input="searchByName"
                            class="w-100" />
                    </div>
                    <div class="col-md-4 el-col-xs-24">
                        <label>Departamento</label>
                        <el-select v-model="department" placeholder="Todos" clearable filterable class="w-100"
                            @change="getPresencesPetitions()">
                            <el-option v-for="item in departments" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </div>
                    <div class="col-md-4 el-col-xs-24">
                        <label>Estado</label>
                        <el-select v-model="state" placeholder="Pendiente" clearable filterable class="w-100"
                            @change="getPresencesPetitions()">
                            <el-option v-for="item in states" :key="item" :label="item.es" :value="item.en" />
                        </el-select>
                    </div>
                </div>
                <div class="row mx-0">
                    <div class="col-md-8">
                        <div class="row date-range-row"> <!-- ← clase añadida -->
                            <div class="col-md-6 date-picker-presence-report">
                                <label>Desde</label>
                                <div class="date-picker col-md-12">
                                    <el-date-picker v-model="fechaDesde" type="date" placeholder="Desde" class="w-100"
                                        :disabled-date="disableDateFrom" @change="watchChangeFrom" format="DD/MM/YYYY"
                                        :prefix-icon="customPrefix" />
                                </div>
                            </div>
                            <div class="col-md-6 date-picker-presence-report"> <!-- ← clase añadida -->
                                <label>Hasta</label>
                                <div class="date-picker col-md-12">
                                    <el-date-picker v-model="fechaHasta" type="date" placeholder="Hasta" class="w-100"
                                        :disabled-date="disableDateTo" @change="watchChangeTo" format="DD/MM/YYYY"
                                        :prefix-icon="customPrefix" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="d-flex justify-content-end align-content-end"
                            style="margin-bottom: -23px; margin-top: 23px; margin-right: -25px;">
                            <button class="btn btn_yellow btn-search btn-new" @click="getPresencesPetitions()">
                                Buscar
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </el-card>
        <!-- Tabla -->
        <div class="table table-users table-not-mobile">
            <div v-if="allPresenceChanges && allPresenceChanges.length > 0">
                <table>
                    <thead>
                        <tr>
                            <th>
                                <div class="d-flex flex-row align-items-center">
                                    <img src="@/assets/icons/user.svg" alt="name-icon"
                                        style="width: 2em; margin-top: -7px;">
                                    <div>NOMBRE</div>
                                </div>
                            </th>
                            <th>
                                <div class="d-flex flex-row align-items-center">
                                    <svg id="chronometer1" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                        viewBox="0 0 233.766 233.766" style="enable-background: new 0 0 233.766 233.766"
                                        xml:space="preserve">
                                        <g>
                                            <path
                                                d="M188.169,79.423l6.059-6.058l2.906,2.906c1.465,1.465,3.384,2.197,5.304,2.197c1.919,0,3.839-0.732,5.303-2.196
                                                                                    c2.93-2.929,2.93-7.678,0.001-10.606l-16.419-16.421c-2.929-2.93-7.678-2.929-10.607-0.001c-2.93,2.929-2.93,7.678-0.001,10.607
                                                                                    l2.907,2.907l-6.06,6.059c-10.441-8.901-22.855-15.553-36.484-19.201c4.082-5.216,6.524-11.773,6.524-18.895
                                                                                    C147.602,13.781,133.821,0,116.883,0c-16.939,0-30.72,13.781-30.72,30.721c0,7.121,2.442,13.679,6.525,18.895
                                                                                    c-13.63,3.647-26.043,10.3-36.485,19.201l-6.059-6.059l2.907-2.907c2.929-2.929,2.928-7.678-0.001-10.607
                                                                                    c-2.93-2.928-7.678-2.929-10.607,0.001L26.024,65.666c-2.929,2.929-2.928,7.678,0,10.606c1.465,1.464,3.384,2.196,5.303,2.196
                                                                                    s3.839-0.732,5.304-2.197l2.906-2.906l6.058,6.058c-13.944,16.357-22.375,37.551-22.375,60.68
                                                                                    c0,51.646,42.017,93.663,93.662,93.663s93.662-42.017,93.662-93.663C210.545,116.974,202.113,95.78,188.169,79.423z
                                                                                    M101.163,30.721c0-8.668,7.052-15.721,15.72-15.721s15.72,7.053,15.72,15.721s-7.052,15.72-15.72,15.72
                                                                                    S101.163,39.389,101.163,30.721z M116.883,218.766c-43.375,0-78.662-35.288-78.662-78.663c0-43.374,35.288-78.662,78.662-78.662
                                                                                    c43.374,0,78.662,35.288,78.662,78.662C195.545,183.477,160.257,218.766,116.883,218.766z" />
                                            <path
                                                d="M116.883,76.981c-4.142,0-7.5,3.357-7.5,7.5v55.621c0,4.143,3.358,7.5,7.5,7.5c4.143,0,7.5-3.357,7.5-7.5V84.481
                                                                                    C124.383,80.339,121.025,76.981,116.883,76.981z" />
                                        </g>
                                    </svg>
                                    <div>
                                        DÍAS CON SOLICITUDES
                                    </div>
                                </div>
                            </th>
                            <th>
                                <div class="d-flex flex-row align-items-center">
                                    <svg id="chronometer1" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                        viewBox="0 0 233.766 233.766" style="enable-background: new 0 0 233.766 233.766"
                                        xml:space="preserve">
                                        <g>
                                            <path
                                                d="M188.169,79.423l6.059-6.058l2.906,2.906c1.465,1.465,3.384,2.197,5.304,2.197c1.919,0,3.839-0.732,5.303-2.196
                                                                                    c2.93-2.929,2.93-7.678,0.001-10.606l-16.419-16.421c-2.929-2.93-7.678-2.929-10.607-0.001c-2.93,2.929-2.93,7.678-0.001,10.607
                                                                                    l2.907,2.907l-6.06,6.059c-10.441-8.901-22.855-15.553-36.484-19.201c4.082-5.216,6.524-11.773,6.524-18.895
                                                                                    C147.602,13.781,133.821,0,116.883,0c-16.939,0-30.72,13.781-30.72,30.721c0,7.121,2.442,13.679,6.525,18.895
                                                                                    c-13.63,3.647-26.043,10.3-36.485,19.201l-6.059-6.059l2.907-2.907c2.929-2.929,2.928-7.678-0.001-10.607
                                                                                    c-2.93-2.928-7.678-2.929-10.607,0.001L26.024,65.666c-2.929,2.929-2.928,7.678,0,10.606c1.465,1.464,3.384,2.196,5.303,2.196
                                                                                    s3.839-0.732,5.304-2.197l2.906-2.906l6.058,6.058c-13.944,16.357-22.375,37.551-22.375,60.68
                                                                                    c0,51.646,42.017,93.663,93.662,93.663s93.662-42.017,93.662-93.663C210.545,116.974,202.113,95.78,188.169,79.423z
                                                                                    M101.163,30.721c0-8.668,7.052-15.721,15.72-15.721s15.72,7.053,15.72,15.721s-7.052,15.72-15.72,15.72
                                                                                    S101.163,39.389,101.163,30.721z M116.883,218.766c-43.375,0-78.662-35.288-78.662-78.663c0-43.374,35.288-78.662,78.662-78.662
                                                                                    c43.374,0,78.662,35.288,78.662,78.662C195.545,183.477,160.257,218.766,116.883,218.766z" />
                                            <path
                                                d="M116.883,76.981c-4.142,0-7.5,3.357-7.5,7.5v55.621c0,4.143,3.358,7.5,7.5,7.5c4.143,0,7.5-3.357,7.5-7.5V84.481
                                                                                    C124.383,80.339,121.025,76.981,116.883,76.981z" />
                                        </g>
                                    </svg>
                                    <div>
                                        EDITAR
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody v-if="showTable">
                        <tr v-for="(sign, index) in allPresenceChanges" :key="index + '-' + sign.employee.fullName">
                            <td>
                                <div class="row-table-image-name-link">
                                    <div class="link-name">
                                        <span @click="openDialog(sign)">
                                            {{ sign.employee.fullName }}
                                        </span>
                                    </div>
                                </div>
                            </td>
                            <td class="text-center">
                                {{ getDaysWithRequests(sign.requestsByDay) }}
                            </td>
                            <td class="pointer" style="text-align: center;">
                                <shared-button-plus icon="eye" @click="openDialog(sign)" title="Editar" />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-else>
                <h5>No se han encontrado cambios según los filtros especificados...</h5>
            </div>
        </div>
        <div class="table-mobile">
            <div v-if="allPresenceChanges && allPresenceChanges.length > 0">
                <div v-for="(sign, index) in allPresenceChanges" :key="index + '-' + sign.employee.fullName">
                    <el-row class="mt-4">
                        <el-card class="card-presence-item">
                            <div class="row d-flex align-items-center">
                                <div class="el-col-xs-24 mb-1">
                                    <span class="presence-item-span">
                                        <img src="@/assets/icons/user.svg" alt="name-icon" width="16" class="me-1" />
                                        <span @click="openDialog(sign)">
                                            {{ sign.employee.fullName }}
                                        </span>
                                    </span>
                                </div>
                                <div class="el-col-xs-20">
                                    <span class="presence-item-span">Días con solicitudes: </span>{{
                                        getDaysWithRequests(sign.requestsByDay) }}
                                </div>
                                <div class="el-col-xs-4 d-flex justify-content-end align-items-center" @click.stop>
                                    <shared-button-plus icon="eye" @click="openDialog(sign)" title="Editar" />
                                </div>
                            </div>
                        </el-card>
                    </el-row>
                </div>
            </div>
            <div v-else>
                <h5>No se han encontrado cambios según los filtros especificados...</h5>
            </div>
        </div>
        <!-- Modal ver cambios empleado -->
        <el-dialog :model-value="isDialogVisible" :center="true" :lock-scroll="true" :show-close="false" :width="760" align-center
            :close-on-click-modal="!uiStore.loading" :close-on-press-escape="!uiStore.loading"
            class="presence-changes-dialog" modal-class="presence-changes-overlay" title="Cambios de presencia"
            @close="closeSeeChanges()">
            <PresenceDialogChanges :isAccessedAdmin="true" :presesenceChanges="employeePresenceChanges"
                v-if="isDialogVisible" @close="closeSeeChanges()" @finish="finishDialogChanges()" />
        </el-dialog>
        <!-- Paginacion -->
        <SharedElementPagination v-model:current-page="pageSignings"
            v-model:page-size="itemsPerPageSignings" size="default" :page-size-options="[10, 20, 50, 100]"
            layout="prev, pager, next, sizes" :total="totalSignins" class="tracker-pagination"
            @change="changePagination" />
    </div>

</template>

<style lang="scss" scoped>
.card-search {
    border-radius: 15px;
    height: 250px;
}

.btn-search {
    max-width: 200px;
}

#chronometer1 {
    fill: $bg-blue;
    width: 2.0em;
    margin-top: -7px;
}

.table-users {
    table {
        thead {
            tr {
                th {
                    padding: 0px !important;
                    margin: 0px !important;
                }
            }
        }

        tbody {
            td {
                .link-name {
                    margin: auto;
                    margin-left: 10px;
                    cursor: pointer;
                }
            }
        }
    }
}

.text-alert {
    font-size: 11px;
    color: black;
    font-weight: 550;
    text-decoration: none;
}



@media (min-width: 768px) {
    .table-mobile {
        display: none;
    }
}

@media (max-width: 767px) {
    .table-not-mobile {
        display: none;
    }

    .date-range-row {
        flex-direction: column;

        .date-picker-presence-report {
            width: 100%;
            max-width: 100%;
            margin-bottom: 12px;

            .el-date-editor {
                width: 100% !important;
            }

            .date-picker {
                width: 100%;
                max-width: 100%;
            }
        }
    }

    .btn-search {
        width: 100%;
    }

    .el-select {
        width: 100%;
    }

    .btn-search {
        width: 100%;
        margin-top: 8px;
    }

    .d-flex.justify-content-end {
        margin-bottom: 0 !important;
        margin-top: 12px !important;
        margin-right: 0 !important;
        justify-content: center !important;
    }

    .table-mobile {
        .card-presence-item {
            width: 100%;
            padding: 10px 0px;
            border-radius: 16px;
            font-size: 15px;

            .presence-item-span {
                color: $bg-blue;
                font-weight: 800;
                font-size: 16px;
                line-height: 100%;
                letter-spacing: -0.05em;
            }
        }
    }
}
</style>
